<template>
  <div class="edit-studio-container edit-studio-comp">
    <div class="admin-header-container admin-header-sec">
      <div :class="{ 'admin-header': studio.id != 'new_studio' }">
        <h1 class="title admin-title-sec" v-if="studio.id != 'new_studio'">{{ $t('edit-studio') + ': ' +
          studio.displayName }}
        </h1>
        <h1 class="title admin-title-sec" v-if="studio.id == 'new_studio'">{{ $t('add-studio') }} </h1>
        <div>
          <div class="img-container" @click="togglePopup(true, false, false, true)">
            <img v-if="studio.photo" width="90" :src="originalStudioPhoto" />
            <img v-if="!studio.photo && studio.id != 'new_studio'" width="90"
              :src="fit20.storageBaseUrl + '/studio/default.svg'" />
          </div>
          <div class="btn-container">
            <span id="cancelStudio" class="fit20-btn cancel-btn-disable" @click="cancelEditing">{{ $t('cancel')
            }}</span>
            <span id="saveStudio" class="fit20-btn save-btn-disable" @click="saveStudio">{{ $t('save') }}</span>
          </div>
        </div>
      </div>
    </div>
    <main class="tab-content">
      <h2 class="item text-secondary">{{ $t('general-info') }}</h2>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_studio_info">
        <div class="field-sec">
          <label>{{ $t('name') }}</label>
          <input type="text" class="form-control" v-model="studio.displayName" />
        </div>
        <div class="field-sec">
          <label>{{ $t('address') }}</label>
          <input type="text" class="form-control" v-model="studio.address" />
        </div>
        <div class="field-sec">
          <label>{{ $t('postal-code') }}</label>
          <input type="text" class="form-control" v-model="studio.postcode">
        </div>
        <div class="field-sec">
          <label>{{ $t('city') }}</label>
          <input type="text" class="form-control" v-model="studio.city">
        </div>
        <div class="field-sec">
          <label class="">{{ $t('country') }}</label>
          <input type="text" class="form-control" v-model="studio.country" />
        </div>
        <div class="field-sec">
          <label class="">{{ $t('email') }}</label>
          <input type="email" class="form-control" v-model="studio.email" />
        </div>
        <div class="field-sec">
          <label class="">{{ $t('open-date') }}</label>
          <input type="date" class="form-control" v-model="studio.openDate" min="2010-01-01" :max="maxDate" />
        </div>
        <div class="field-sec">
          <label for="editedStudio_gatewayIPAddress" class="">{{ $t('sensor') }}</label>
          <select id="editedStudio_gatewayIPAddress" class="custom-select w-100" v-model="studio.sensor">
            <option :value="false">{{ $t('no') }}</option>
            <option :value="true">{{ $t('yes') }}</option>
            <!-- <option value="core-riseapps.js">Core - Riseapps</option> -->
            <!-- <option value="fakesensor.js">Sensor simulator</option> -->
          </select>
        </div>
        <div class="field-sec">
          <label>{{ $t('language') }}</label>
          <select class="" v-model="studio.language">
            <option v-for="language in fit20.languages" :value="language.code" :key="language.code">{{ language.name }}
            </option>
          </select>
        </div>
        <div class="field-sec">
          <label>{{ $t('active') }}</label>
          <select v-model="studio.active">
            <option :value="true">{{ $t('yes') }}</option>
            <option :value="false">{{ $t('no') }}</option>
          </select>
          <!-- <input type="checkbox" class="switch_1" v-model="studio.active" /> -->
        </div>
        <!-- <div class="field-sec">
          <label>{{ $t('trio') }}</label>
          <select v-model="studio.trio">
            <option :value="true">{{ $t('yes') }}</option>
            <option :value="false">{{ $t('no') }}</option>
          </select>
        </div> -->
        <!-- <div class="fade">
          <label></label>
          <input type="test" />
        </div> -->
        <!-- just to correct the display -->
        <AddRemoveItem v-if="studio.id != 'new_studio'" containerClass="users-col" title="studio-manager"
          :data="studioMangers" :selectItem="selectTrainer" :removeItem="removeUserFromStudio"
          :togglePopup="togglePopup" :popupParams="[true, true, false]" name1="firstName" name2="lastName"
          :fit20="fit20">
        </AddRemoveItem>
        <AddRemoveItem v-if="studio.id != 'new_studio'" containerClass="users-col" title="trainers" :data="trainers"
          :selectItem="selectTrainer" :removeItem="removeUserFromStudio" :togglePopup="togglePopup" :fit20="fit20"
          :popupParams="[true, false, false]" name1="firstName" name2="lastName"></AddRemoveItem>
        <AddRemoveItem v-if="studio.id != 'new_studio'" title="machines" :data="studioMachines" :selectItem="selectItem"
          :removeItem="removeMachineFromStudio" :togglePopup="togglePopup" :popupParams="[true, false, true]"
          name1="brand" name2="name" :fit20="fit20"></AddRemoveItem>
        <div class="fade"></div>
      </form>
    </main>
    <div class="popup-overlay" v-if="showMachinePopup">
      <div class="popup-content">
        <!-- <div>{{ $t() }}</div> -->
        <div class="flex popup-title">
          <div>{{ $t('ad-2-studio') }}</div>
          <div @click="togglePopup(false, false, true)"><img :src="fit20.storageBaseUrl + '/static/icons/x.svg'"
              width="40px" /></div>
        </div>
        <input type="text" @input="openSelectDropdown" @click="openSelectDropdown" v-model="machineFilter"
          :placeholder="$t('placeholder1')" />
        <div v-show="isDropdownOpen" class="dropdown-container">
          <div class="dropdown-options">
            <div v-for="machine in machines" :key="machine.value" @click="selectAnItem(machine)"
              class="dropdown-option">
              {{ machine.brand + " " + machine.name }}
            </div>
          </div>
        </div>
        <div class="btn-container">
          <span class="fit20-btn cancel-btn-disable" @click="togglePopup(false, false, true)">{{ $t('cancel') }}</span>
          <span class="fit20-btn save-btn-disable" @click="addItem('machines')">{{ $t('ok') }}</span>
        </div>
      </div>
    </div>
    <div class="popup-overlay" v-if="showUserPopup">
      <div class="popup-content">
        <div class="flex popup-title">
          <div>{{ $t('ad-2-studio') }}</div>
          <div @click="togglePopup"><img :src="fit20.storageBaseUrl + '/static/icons/x.svg'" width="40px" /></div>
        </div>
        <input type="text" @input="openSelectDropdown" @click="openSelectDropdown" v-model="userFilter"
          :placeholder="$t('placeholder1')" />
        <div v-show="isDropdownOpen" class="dropdown-container">
          <div class="dropdown-options">
            <div v-for="user in users" :key="user.value" @click="selectAnItem(user, true)" class="dropdown-option">
              {{ user.firstName + ' ' + user.lastName }}
            </div>
          </div>
        </div>
        <div class="btn-container">
          <span class="fit20-btn cancel-btn-disable" @click="togglePopup">{{ $t('cancel') }}</span>
          <span class="fit20-btn save-btn-disable" @click="addItem('users')">{{ $t('ok') }}</span>
        </div>
      </div>
    </div>
    <div class="popup-overlay" v-if="showPhotoPopup">
      <Photo :title="studio.displayName" :id="studio.id" :changePhoto="changePhoto" :savePhoto="savePhoto"
        :togglePopup="togglePopup" :photo="studioPhoto" :fit20="fit20"
        :togglePopupValues="[false, false, false, true]" />
      <!-- <div class="popup-content">
      <div>{{ $t('take-pic')+": "+ studio.name }}</div>
      <div class="btn btn-emphasis inputFileHidden">
        <span class="img-container">
          <img :id="'edit_photo1'+studio.id" width="200" :src="studioPhoto" />
          <img class="img-ico" :src="fit20.storageBaseUrl+'/static/icons/%2Bfoto.svg'" />
        </span>
        <input name="image" type="file" class="form-control" accept="image/*" capture="camera" @change="changePhoto">
      </div>
      <div class="btn-container">
        <span class="fit20-btn cancel-btn-disable" @click="togglePopup(false,false,false,true)">{{ $t('cancel') }}</span>
        <span class="fit20-btn save-btn-disable" @click="savePhoto">{{ $t('ok') }}</span>
      </div>
    </div> -->
    </div>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';
import AddRemoveItem from './AddRemoveItem.vue';
import Photo from '../Photo.vue';
import { isValidEmail } from "../../actions/global.js";
export default {
  name: 'Studio',
  components: {
    AddRemoveItem,
    Photo
  },
  props: ["user", "selectTab", "admin_fit20", "fit20", "formatDate"],
  data() {
    return {
      studio: {},
      users: [],
      machines: [],
      studioMachines: [],
      studioMangers: [],
      trainers: [],
      originalStudio: {},
      updated: false,
      maxDate: this.formatDate(new Date()),
      originalUsers: [],
      originalMachines: [],
      showMachinePopup: false,
      showPhotoPopup: false,
      showUserPopup: false,
      userFilter: "",
      isFilter: false,
      isDropdownOpen: false,
      userRole: 'trainer',
      machineFilter: "",
      selectedItem: "",
      // defaultStudioPhoto: "http://storage.googleapis.com/fit20app-4-acctest.appspot.com/studio/defult.svg",
      studioPhoto: "",
      newPhoto: false,
      originalStudioPhoto: "",

    };
  },
  methods: {
    // isValidEmail: function (email) {
    //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //   return emailRegex.test(email);
    // },
    selectTrainer: function () {
      console.log("should go to selected item");
    },
    selectItem: function () {
      console.log("should go to selected item");
    },
    saveStudio: async function () {
      if (isEqual(this.studio, this.originalStudio)) {
        alert(this.$t('general-no-changes'));
      } else if (!this.studio.displayName) {
        alert(this.$t('required-field').replace('{field}', this.$t('name')));
      } else if (!this.studio.language) {
        alert(this.$t('required-field').replace('{field}', this.$t('language')));
      } else if (!isValidEmail(this.studio.email)) {
        alert(this.$t('invalid-email'));
      } else {
        if (this.studio.id == "new_studio") {
          this.studio.id = false;
        }
        this.studio.name = this.studio.displayName.toLowerCase();
        let updateStudio = await fetch(this.fit20.baseUrl + "/api/studios/mohammad_test@test.com?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.studio),
        });
        let updatedStudio = await updateStudio.json();
        this.admin_fit20.studio = updatedStudio;

        if (!this.studio.id) {
          this.fit20.studios = [...this.fit20.studios, updatedStudio];
        }
        this.admin_fit20.user = '';
        this.updated = true;
      }
    },
    cancelEditing: function () {
      if (!isEqual(this.studio, this.originalStudio)) {
        this.admin_fit20.studio = {
          ...this.originalStudio
        };
        this.updated = true;
      }
    },
    removeUserFromStudio: function (userId) {
      this.studio.users = this.studio.users.filter(user => user.id != userId);
    },
    removeMachineFromStudio: function (machineId) {
      this.studio.machines = this.studio.machines.filter(machine => machine.id != machineId);
    },
    addItem: function (item) {
      this.studio[item] = [...this.studio[item], this.selectedItem];
      this.isFilter = false;
      this.showUserPopup = false;
      this.showMachinePopup = false;
    },
    togglePopup: async function (open, role, machine, photo) {
      this.userFilter = "";
      this.machineFilter = "";
      if (!machine && !photo) {
        if (open && !this.users.length) {
          let getTrainers = await fetch(this.fit20.baseUrl + "/api/users/list?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
          this.users = await getTrainers.json();
          this.users = this.users.filter(user => !this.studioMangers.some(studioManger => studioManger.id == user.id) && !this.trainers.some(trainer => trainer.id == user.id));
          this.originalUsers = [...this.users];
        } else if (this.users.length > 0) {
          this.users = [...this.originalUsers];
          this.users = this.users.filter(user => !this.studioMangers.some(studioManger => studioManger.id == user.id) && !this.trainers.some(trainer => trainer.id == user.id));
        }
        this.userRole = role ? "studio manager" : "trainer";
        this.showUserPopup = !this.showUserPopup;
        // console.log("userss popup");
      } else if (photo) {
        console.log("photo");

        this.showPhotoPopup = !this.showPhotoPopup;

        // this.studioPhoto = this."/studio/1111.svg";
      } else {

        this.originalMachines = [...this.machines];
        this.showMachinePopup = !this.showMachinePopup;
        // console.log("machines popup");
      }

    },
    openSelectDropdown: function () {
      this.isDropdownOpen = true;
    },
    selectAnItem(item, user) {
      if (user) {
        this.userFilter = item.firstName + " " + item.lastName;
        item.role = this.userRole;
      } else {
        this.machineFilter = item.brand + " " + item.name;
      }
      this.selectedItem = item;
      this.isDropdownOpen = false;
    },
    changePhoto: function (e) {
      const file = e.target.files[0]; // Get the first selected file

      if (file) {
        // Use FileReader to read the selected file
        const reader = new FileReader();
        reader.onload = (e) => {
          this.studioPhoto = e.target.result; // Set the imageUrl to the data URL
          this.newPhoto = e.target.result;;
        };
        reader.readAsDataURL(file);
      }
    },
    savePhoto: async function () {
      if (this.newPhoto) {
        console.log("there is a new photo");
        const formData = new FormData();
        formData.append('image', this.newPhoto);
        // Check the formData content
        // console.log(formData);
        const res = await fetch(this.fit20.baseUrl + "/api/photos/studio/" + this.studio.id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
          method: 'POST',
          body: formData,
        });
        if (res.ok) {
          console.log("Upload photo done");
          this.studio.photo = true;
          let updatedStudio = this.fit20.studios.find(studio => studio.id == this.studio.id);
          if (updatedStudio) {
            updatedStudio.photo = await res.json();
          }
        } else {
          // Handle errors (e.g., show an error message)
          alert('Upload failed.');
          console.error('Upload failed.');
        }
      }
      console.log("save photo");
      this.originalStudioPhoto = JSON.parse(JSON.stringify(this.newPhoto));
      // to do : change the photo in the studios array.............................

      this.newPhoto = false;
      this.showPhotoPopup = !this.showPhotoPopup;
    },
    // handleImageError(event) {
    //   event.target.src = this.defaultStudioPhoto; // Set the src to the default image path
    // },
  },
  watch: {
    'admin_fit20.studio': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        if (!newVal) {
          this.studio.id = '';
        }
        if (newVal && newVal.id && (!this.studio.id || this.studio.id != newVal.id || this.updated)) {
          this.studio = newVal;
          // console.log(this.studio.members[0])
          let notMainMembers = this.studio.members.filter(member => member.firstName != '---' && member.status == 'member' && member.main == false);

          let mainMembers = this.studio.members.filter(member => member.firstName != '---' && member.status == 'member' && member.main == true);

          // console.log(notMainMembers.length);
          // console.log(mainMembers.length); 3
          // console.log(notMainMembers);
          this.studioMangers = newVal.users.filter(user => user.role == "studio manager");
          this.trainers = newVal.users.filter(user => user.role == "trainer");
          // console.log(this.studioMangers);
          // console.log(this.trainers);
          this.studio.openDate = this.formatDate(this.studio.openDate);
          this.originalStudio = {
            ...newVal
          };
          this.originalStudio.openDate = this.formatDate(this.originalStudio.openDate);
          this.machines = this.admin_fit20.machines.filter(machine => !this.studio.machines.some(studioMachine => studioMachine.id == machine.id));
          this.studioMachines = this.admin_fit20.machines.filter(machine => this.studio.machines.some(studioMachine => studioMachine.id == machine.id));
          this.studioPhoto = this.fit20.storageBaseUrl + "/studio/" + (this.studio.photo ? this.studio.id + ".png?generation=" + this.studio.photo : "default.svg");
          this.originalStudioPhoto = this.fit20.storageBaseUrl + "/studio/" + (this.studio.photo ? this.studio.id + ".png?generation=0" : "default.svg");
          if (!this.studio.id || this.studio.id != newVal.id) {
            this.selectTab('#admin_studio_info');
          }
          this.updated = false;
        }
      }
    },
    studio: {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        if (isEqual(newVal, this.originalStudio)) {
          $('#cancelStudio').removeClass("cancel-btn-active");
          $('#saveStudio').removeClass("save-btn-active");
        } else {
          if (!$('#cancelStudio').hasClass('cancel-btn-active')) {
            $('#cancelStudio').addClass("cancel-btn-active");
            $('#saveStudio').addClass("save-btn-active");
          }
        }
        if (newVal.users.length != this.originalStudio.users.length) {
          if (isEqual(newVal.users, this.originalStudio))
            this.studioMangers = newVal.users.filter(user => user.role == "studio manager");
          this.trainers = newVal.users.filter(user => user.role == "trainer");
        }
      }
    },
    'studio.users': {
      deep: true,
      handler(newVal) {
        this.studioMangers = newVal.filter(user => user.role == "studio manager");
        this.trainers = newVal.filter(user => user.role == "trainer");
        this.users = this.users.filter(user => !this.studioMangers.some(studioManger => studioManger.id == user.id) && !this.trainers.some(trainer => trainer.id == user.id));
      }
    },
    userFilter: {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        if (newVal.length > 0) {
          this.users = [...this.originalUsers].filter(user => (user.firstName + " " + user.lastName).includes(newVal.toLowerCase().trim()));
          this.isFilter = true;
        } else if (this.isFilter) {
          this.users = [...this.originalUsers];
          this.isFilter = false;
        }
      }
    },
    machineFilter: {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        if (newVal.length > 0) {
          this.machines = [...this.originalMachines].filter(machine => (machine.brand + " " + machine.name).toLowerCase().includes(newVal.toLowerCase().trim()));
          this.isFilter = true;
        } else if (this.isFilter) {
          this.machines = [...this.originalMachines];
          this.isFilter = false;
        }
      }
    },
    'admin_fit20.machines': {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        console.log("watch admin machines")
        this.machines = newVal;
      }
    },
    'studio.machines': {
      deep: true,
      handler(newVal) {
        if (this.studio && this.studio.machines.length > 0) {
          this.machines = this.admin_fit20.machines.filter(machine => !this.studio.machines.some(studioMachine => studioMachine.id == machine.id));
          this.studioMachines = this.admin_fit20.machines.filter(machine => this.studio.machines.some(studioMachine => studioMachine.id == machine.id));
        }
      }
    }
  }
};
</script>

<style>
.edit-studio-comp .img-container img {
  border-radius: 10px;
}

.edit-studio-comp.edit-studio-container {
  width: 100%;
  height: calc(100vh - 30px);
  /* Adjust as needed */
  overflow: auto;
}

.edit-studio-comp .tab-content {
  padding-top: 15px;
}

.edit-studio-comp .tab-content h2 {
  margin-left: 10px;
}

.edit-studio-comp .admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.edit-studio-comp .form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.edit-studio-comp .form-container div:not(.add-item) {
  width: calc(100% / 2 - 30px);
}

.edit-studio-comp .form-container label {
  display: block;
}

.edit-studio-comp .studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.edit-studio-comp .users-col {
  width: calc(100%);
}

.edit-studio-comp .studio-machines {
  width: 100%;
}
</style>
